import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus, IAnalyticsProduct } from '../../../types/analytics';

interface ITrackNewOfferLinkClickParams {
  analyticsOfferStatus: TAnalyticsOfferStatus;
  analyticsProduct: IAnalyticsProduct;
}

export const trackNewOfferLinkClick = (params: ITrackNewOfferLinkClickParams) => {
  const { analyticsOfferStatus, analyticsProduct } = params;

  ca('eventSite', {
    name: 'oldevent',
    category: analyticsOfferStatus,
    action: 'Click',
    label: 'new_announcement_button',
    products: [analyticsProduct],
  });
};
